module.exports = __webpack_public_path__ + "static/123-6e656fa0b98ad2a15b514dd515a2e9a6.jpeg";